<template>
    <div>
        <div v-if="label" class="h3 py-0">{{ label }}</div>

        <vue-bootstrap-typeahead
            show-items-on-empty-query
            v-model="mobileSearch"
            :min-matching-chars="1"
            :max-matches="maxMatches"
            :data="models"
            :serializer="s => s[0]"
            :placeholder="placeholder"
            @hit="goToModel($event)"
        />

    </div>
</template>

<script>

import VueBootstrapTypeahead from "./VueBootstrapTypeahead.vue";
import { debounce } from "../../../helper/debounce";

export default {

    name: "mobile-finder",

    components: {
        VueBootstrapTypeahead
    },

    props:
    {
        label:
        {
            type: String,
            default: null
        },
        placeholder:
        {
            type: String,
            default: null
        },
        maxMatches: {
            type: Number,
            default: 100
        },
        apiUrl:
        {
            type: String,
            default: null
        }
    },

    data()
    {
      return {
        query: '',
        mobileSearch: '',
        models: []
      }
    },

    methods:
    {
        getMobiles()
        {
            if (this.models.length < 1) {
                fetch(this.apiUrl)
                    .then(response => response.json())
                    .then(data => this.models = data);
            }
        },
        goToModel(model)
        {
            window.location.href = model[1] + window.location.search;
        }
    },

    watch:
    {
        mobileSearch()
        {
            this.getMobiles()
        }
    }
}
</script>
